import { createSelector, createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../actions/SetDefinitions';
import { sessionID } from '../util/unique';
import Ajax from '../util/ajax';
const initialState = {};
export const entitiesSlice = createSlice({
    name: 'entities',
    initialState,
    reducers: {
        entitiesCleared: () => {
            return {};
        },
        entityUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        entityDeleted: (state, action) => {
            delete state[action.payload];
        },
        entitiesReplaced: (state, action) => {
            const newState = {};
            for (const o of action.payload) {
                newState[o.id] = o;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (_, action) => {
            const newState = {};
            for (const o of action.payload.entities) {
                newState[o.id] = o;
            }
            return newState;
        });
    }
});
export const selectEntities = (state) => state.definitions.entities;
export const selectEntity = (id) => (state) => id == undefined ? undefined : state.definitions.entities[id];
const selectDeviceId = (_state, deviceId) => deviceId;
export const selectEntitiesForDevice = createSelector([selectEntities, selectDeviceId], selectForDevice);
export function selectForDevice(entities, device_id) {
    const deviceEntities = [];
    for (const e of Object.values(entities)) {
        if (e.device_id == device_id) {
            deviceEntities.push(e);
        }
    }
    return deviceEntities;
}
// this is to use as:
//   useEffect(() => subscribeEntities(dispatch, foo))
export const subscribeEntities = (dispatch, entities) => {
    const sid = sessionID();
    const ajax = new Ajax(dispatch, true);
    const entityIds = entities.map((e) => e.id);
    ajax.post('/backend/subscribe/entities?sid=' + sid, entityIds);
};
export const selectThermometerEntities = createSelector([selectEntities], selectThermometerEntitiesFromSlice);
export function selectThermometerEntitiesFromSlice(entities) {
    const result = [];
    for (const e of Object.values(entities)) {
        if (e.title == 'temperature') {
            result.push(e);
        }
    }
    return result;
}
export function findEntity(entities, title) {
    for (const e of entities) {
        if (e.title === title) {
            return e;
        }
    }
    return undefined;
}
export const { entitiesCleared, entityUpdated, entityDeleted, entitiesReplaced } = entitiesSlice.actions;
export const entityAdded = entityUpdated;
export default entitiesSlice.reducer;
